import { gql } from '@apollo/client';

// RITA-1541: Bearbeitungssperre, wie Liste und Editor sie anzeigen. Die Fensterkennung selbst
// kommt nie vom Server; `this_window` ist nur der Vergleich mit der mitgeschickten Kennung.
const CONTRACT_TEMPLATE_LOCK_FIELDS = gql`
  fragment ContractTemplateLockFields on ContractTemplateLock {
    user_id
    display_name
    started_at
    last_activity_at
    is_mine
    this_window
  }
`;

const CONTRACT_TEMPLATE_FIELDS = gql`
  fragment ContractTemplateFields on ContractTemplate {
    id
    name
    description
    content
    variables_used
    created_by
    created_at
    updated_at
    assignment {
      kind
      branch_office_id
      branch_office_name
      contract_type_id
      contract_type_name
      gender
    }
    lock {
      ...ContractTemplateLockFields
    }
  }
  ${CONTRACT_TEMPLATE_LOCK_FIELDS}
`;

export const GET_CONTRACT_TEMPLATES = gql`
  query getContractTemplates($search: String) {
    getContractTemplates(search: $search) {
      ...ContractTemplateFields
    }
  }
  ${CONTRACT_TEMPLATE_FIELDS}
`;

/** RITA-1541: Nachsehen im Editor (etwa im Minutentakt und beim Zurückwechseln ins Fenster). */
export const GET_CONTRACT_TEMPLATE_LOCK = gql`
  query getContractTemplateLock($id: Int!, $token: String) {
    getContractTemplateLock(id: $id, token: $token) {
      ...ContractTemplateLockFields
    }
  }
  ${CONTRACT_TEMPLATE_LOCK_FIELDS}
`;

/** RITA-1541: Sperre beim Öffnen anfordern, bei Eingaben auffrischen, im zweiten Fenster weiterarbeiten. */
export const ACQUIRE_CONTRACT_TEMPLATE_LOCK = gql`
  mutation acquireContractTemplateLock($id: Int!, $token: String!, $switchWindow: Boolean) {
    acquireContractTemplateLock(id: $id, token: $token, switch_window: $switchWindow) {
      acquired
      lock {
        ...ContractTemplateLockFields
      }
    }
  }
  ${CONTRACT_TEMPLATE_LOCK_FIELDS}
`;

/** RITA-1541: Sperre dieses Fensters beim Schließen freigeben. */
export const RELEASE_CONTRACT_TEMPLATE_LOCK = gql`
  mutation releaseContractTemplateLock($id: Int!, $token: String!) {
    releaseContractTemplateLock(id: $id, token: $token)
  }
`;

export const GET_CONTRACT_TEMPLATE = gql`
  query getContractTemplate($id: Int!) {
    getContractTemplate(id: $id) {
      id
      name
      description
      document
      assignment {
        kind
        branch_office_id
        branch_office_name
        contract_type_id
        contract_type_name
        gender
      }
      created_by
      created_at
      updated_at
    }
  }
`;

export const CREATE_CONTRACT_TEMPLATE = gql`
  mutation createContractTemplate($input: ContractTemplateInput!) {
    createContractTemplate(input: $input) {
      id
      name
      description
      updated_at
    }
  }
`;

// RITA-1541: `expectedUpdatedAt` = Stand beim Öffnen bzw. letzten Speichern → Fehler CONFLICT statt
// stillem Überschreiben; ohne den Wert („Trotzdem speichern“) wird bewusst überschrieben.
// `lockToken`: erfolgreiches Speichern beendet die Sperre dieses Fensters.
export const UPDATE_CONTRACT_TEMPLATE = gql`
  mutation updateContractTemplate(
    $input: ContractTemplateUpdate!
    $id: Int!
    $expectedUpdatedAt: String
    $lockToken: String
  ) {
    updateContractTemplate(input: $input, id: $id, expected_updated_at: $expectedUpdatedAt, lock_token: $lockToken) {
      id
      name
      description
      updated_at
    }
  }
`;

export const DELETE_CONTRACT_TEMPLATE = gql`
  mutation deleteContractTemplate($id: Int!) {
    deleteContractTemplate(id: $id)
  }
`;

/** RITA-1546: dieselbe Regel wie beim Speichern; der Hinweis ersetzt keine Speicherprüfung. */
export const GET_ASSIGNMENT_CONFLICTS = gql`
  query getContractTemplateAssignmentConflicts($assignment: ContractTemplateAssignmentInput!, $excludeId: Int) {
    getContractTemplateAssignmentConflicts(assignment: $assignment, exclude_id: $excludeId) {
      reason
      template {
        id
        name
        assignment {
          kind
          branch_office_id
          branch_office_name
          contract_type_id
          contract_type_name
          gender
        }
      }
    }
  }
`;
